import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import GalleryApply from "@/pages/GalleryApply";
import GalleryApplyReceived from "@/pages/GalleryApplyReceived";
import GalleryBuy from "@/pages/GalleryBuy";
import ArtCentre from "@/pages/ArtCentre";
import CeramicStudio from "@/pages/CeramicStudio";
import Cafe from "@/pages/Cafe";
import Stage from "@/pages/Stage";
import Coworking from "@/pages/Coworking";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Confirmation from "@/pages/Confirmation";
import Contact from "@/pages/Contact";
import Artists from "@/pages/Artists";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";

import AdminLogin from "@/pages/admin/Login";
import AdminForgotPassword from "@/pages/admin/ForgotPassword";
import AdminResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminEvents from "@/pages/admin/EventsAdmin";
import AdminBookings from "@/pages/admin/BookingsAdmin";
import AdminContacts from "@/pages/admin/ContactsAdmin";
import AdminGalleryApplications from "@/pages/admin/GalleryApplications";
import AdminArtworks from "@/pages/admin/ArtworksAdmin";
import AdminArtists from "@/pages/admin/ArtistsAdmin";
import AdminPageGalleries from "@/pages/admin/PageGalleriesAdmin";
import AdminResourcePools from "@/pages/admin/ResourcePoolsAdmin";
import AdminAnalytics from "@/pages/admin/Analytics";
import AdminMenu from "@/pages/admin/MenuAdmin";
import ScrollToTop from "@/components/ScrollToTop";
import PageTracker from "@/components/PageTracker";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <PageTracker />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/apply" element={<GalleryApply />} />
            <Route path="/gallery/apply/received/:id" element={<GalleryApplyReceived />} />
            <Route path="/gallery/buy" element={<GalleryBuy />} />
            <Route path="/art-centre" element={<ArtCentre />} />
            <Route path="/ceramic" element={<CeramicStudio />} />
            <Route path="/cafe" element={<Cafe />} />
            <Route path="/stage" element={<Stage />} />
            <Route path="/coworking" element={<Coworking />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/confirmation/:id" element={<Confirmation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="artworks" element={<AdminArtworks />} />
            <Route path="artists" element={<AdminArtists />} />
            <Route path="page-galleries" element={<AdminPageGalleries />} />
            <Route path="resource-pools" element={<AdminResourcePools />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="gallery-applications" element={<AdminGalleryApplications />} />
            <Route path="contacts" element={<AdminContacts />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
